<template>
  <div
    :style="{ display: isShow ? 'block' : 'none' }"
    class="popup modify_site"
  >
    <div class="popup_header">
      <div class="header_title">유류 공급서 등록</div>
      <button class="close_popup" @click="close">
        <img src="/img/common/popup_close.svg" alt="팝업 닫기" />
      </button>
    </div>
    <div class="popup_content">
      <div class="form_wrap">
        <!-- 1행: 공급일 + 선박명 -->
        <div class="form_item">
          <div class="form_write">
            <p class="title">공급일</p>
            <p class="input">
              <date-picker
                v-model="param.supplyDay"
                :lang="getLang"
                value-type="format"
                format="YYYY-MM-DD"
                type="date"
              />
            </p>
            <p class="title" style="margin-left: 20px">선박명</p>
            <p class="input">
              <select v-model="param.shipId">
                <option value="" disabled>선택하세요</option>
                <option
                  v-for="(item, index) in equipList"
                  :key="index"
                  :value="item.id"
                >
                  {{ item.name }}
                </option>
              </select>
            </p>
          </div>
        </div>

        <!-- 2행: 첨부파일 -->
        <div class="form_item">
          <div class="form_write">
            <p class="title">첨부파일</p>
            <p v-if="param.fileId" class="input file-input">
              <a
                v-for="(file, index) in fileList"
                :key="index"
                style="cursor: pointer"
                @click="onClickDownload(file)"
              >
                <span class="files"> 📎 {{ file.ogName }} </span>
              </a>
              <a v-show="!param.isReadOnly" @click="removeFile">
                <span class="file-del">삭제</span>
              </a>
            </p>
            <p v-else class="input file-input">
              <label for="actionDocFile" class="file-upload-label">
                📁 파일 선택
              </label>
              <span class="no-file-text">선택된 파일 없음</span>
              <input
                id="actionDocFile"
                ref="actionDocFile"
                type="file"
                :accept="DOC_ALLOW_FILE"
                style="display: none"
                @change="doActionDocFileAttach"
              />
            </p>
          </div>
        </div>

        <!-- 3행: 유종 + 주유량 -->
        <div class="form_item">
          <div class="form_write">
            <p class="title">유종</p>
            <p class="input">
              <select v-model="param.oilType">
                <option value="" disabled>선택하세요</option>
                <option value="경유">경유</option>
                <option value="휘발유">휘발유</option>
                <option value="등유">등유</option>
                <option value="LPG">LPG</option>
                <option value="중유">중유</option>
              </select>
            </p>
            <p class="title" style="margin-left: 20px">주유량(L)</p>
            <p class="input">
              <input
                :value="formatNumber(param.oilAmount)"
                type="text"
                class="number-input"
                @input="
                  onNumberInput('oilAmount', $event);
                  calculateOilPrice();
                "
                @keypress="onlyNumber"
              />
            </p>
          </div>
        </div>

        <!-- 4행: 단가 + 유류대금(자동계산) -->
        <div class="form_item">
          <div class="form_write">
            <p class="title">단가(원)</p>
            <p class="input">
              <input
                :value="formatNumber(param.unitPrice)"
                type="text"
                class="number-input"
                @input="
                  onNumberInput('unitPrice', $event);
                  calculateOilPrice();
                "
                @keypress="onlyNumber"
              />
            </p>
            <p class="title" style="margin-left: 20px">유류대금(원)</p>
            <p class="input">
              <input
                :value="formatNumber(param.oilPrice)"
                type="text"
                readonly
                class="readonly-input number-input"
              />
            </p>
          </div>
        </div>

        <!-- 5행: 수수료 + 용역비 -->
        <div class="form_item">
          <div class="form_write">
            <p class="title">수수료(원)</p>
            <p class="input">
              <input
                :value="formatNumber(param.extraPrice)"
                type="text"
                class="number-input"
                @input="
                  onNumberInput('extraPrice', $event);
                  calculateTotalPrice();
                "
                @keypress="onlyNumber"
              />
            </p>
            <p class="title" style="margin-left: 20px">용역비(원)</p>
            <p class="input">
              <input
                :value="formatNumber(param.servicePrice)"
                type="text"
                class="number-input"
                @input="
                  onNumberInput('servicePrice', $event);
                  calculateTotalPrice();
                "
                @keypress="onlyNumber"
              />
            </p>
          </div>
        </div>

        <!-- 6행: 합계(자동계산) -->
        <div class="form_item">
          <div class="form_write">
            <p class="title">합계(원)</p>
            <p class="input">
              <input
                :value="formatNumber(param.totalPrice)"
                type="text"
                readonly
                class="readonly-input total-price number-input"
              />
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="popup_footer">
      <div class="foot_btns">
        <button
          v-if="param.id"
          type="button"
          class="delete"
          @click="confirmDelete"
        >
          삭제
        </button>
        <button type="button" class="cancel" @click="close">취소</button>
        <button type="button" class="comfirm" @click="save">확인</button>
      </div>
    </div>
  </div>
</template>
<script>
import "vue2-datepicker/index.css";
import DatePicker from "vue2-datepicker";
import { mapGetters } from "vuex";
import EquipmentApi from "../../api/osm/EquipmentApi";
import OilDocumentApi from "../../api/osm/OilDocumentApi";
import FileApi from "../../api/coco/FileApi";
import FileHelper from "../../helper/FileHelper";

export default {
  name: "PopupCreateEquipment",
  components: { DatePicker },
  props: {},
  data: () => {
    return {
      isShow: false,
      param: {
        fileId: null,
        supplyDay: "",
        shipId: "",
        oilType: "",
        oilAmount: null,
        unitPrice: null,
        oilPrice: 0,
        extraPrice: null,
        servicePrice: null,
        totalPrice: 0,
      },
      day: [],
      equipList: [],
      fileList: [],
      DOC_ALLOW_FILE: FileHelper.allowFileExt(),
    };
  },
  computed: { ...mapGetters(["getLang"]) },
  watch: {},
  created() {},
  async mounted() {
    const result = await EquipmentApi.equipList();
    result.content.forEach((element) => {
      this.equipList.push(element);
    });
  },
  beforeDestroy() {},
  methods: {
    getToday() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    async open(param) {
      if (param) {
        this.param = { ...param };
        if (param.fileId) {
          this.fileList = await FileApi.list(this.param.fileId);
        }
      } else {
        // 신규 등록 시 당일 날짜 기본값
        this.param.supplyDay = this.getToday();
      }
      this.isShow = true;
    },
    close() {
      this.day = [];
      this.param = {
        fileId: null,
        supplyDay: "",
        shipId: "",
        oilType: "",
        oilAmount: null,
        unitPrice: null,
        oilPrice: 0,
        extraPrice: null,
        servicePrice: null,
        totalPrice: 0,
      };
      this.fileList = [];
      this.isShow = false;
    },
    calculateOilPrice() {
      const amount = parseFloat(this.param.oilAmount) || 0;
      const unitPrice = parseFloat(this.param.unitPrice) || 0;
      this.param.oilPrice = Math.round(amount * unitPrice);
      this.calculateTotalPrice();
    },
    calculateTotalPrice() {
      const oilPrice = parseFloat(this.param.oilPrice) || 0;
      const extraPrice = parseFloat(this.param.extraPrice) || 0;
      const servicePrice = parseFloat(this.param.servicePrice) || 0;
      this.param.totalPrice = Math.round(oilPrice + extraPrice + servicePrice);
    },
    onlyNumber(event) {
      const charCode = event.which ? event.which : event.keyCode;
      // 숫자(48-57)와 소수점(46) 허용
      if ((charCode < 48 || charCode > 57) && charCode !== 46) {
        event.preventDefault();
      }
    },
    onNumberInput(field, event) {
      // 콤마 제거 후 숫자만 추출
      const value = event.target.value.replace(/[^0-9.]/g, "");
      this.param[field] = value ? Number(value) : null;
    },
    formatNumber(value) {
      if (value === null || value === undefined || value === "") return "";
      // 소수점이 있는 경우 처리
      const num = Number(value);
      if (isNaN(num)) return "";
      return num.toLocaleString("ko-KR");
    },
    async save() {
      if (!this.param.supplyDay) {
        this.$toast.error("공급일을 입력해주세요.");
        return;
      }
      if (!this.param.shipId) {
        this.$toast.error("선박명을 선택해주세요.");
        return;
      }
      if (this.param.id) {
        await OilDocumentApi.updateOilDoc(this.param.id, this.param);
      } else {
        await OilDocumentApi.saveOilDoc(this.param);
      }
      this.param = {
        fileId: null,
        supplyDay: "",
        shipId: "",
        oilType: "",
        oilAmount: null,
        unitPrice: null,
        oilPrice: 0,
        extraPrice: null,
        servicePrice: null,
        totalPrice: 0,
      };
      this.fileList = [];
      this.isShow = false;
      this.$emit("confirmCallback");
    },
    changePriceInput() {
      const servicePrice = parseFloat(this.param.servicePrice) || 0;
      const extraPrice = parseFloat(this.param.extraPrice) || 0;
      const oilPrice = parseFloat(this.param.oilPrice) || 0;
      this.param.totalPrice = servicePrice + extraPrice + oilPrice;
    },
    async onClickDownload(file) {
      FileApi.download(file.fileId, file.fileNo);
    },
    removeFile() {
      this.param.fileId = null;
    },
    async confirmDelete() {
      if (!confirm("유류 공급서를 삭제하시겠습니까?")) {
        return;
      }
      try {
        await OilDocumentApi.deleteOilDoc(this.param.id);
        this.$toast.success("삭제되었습니다.");
        this.close();
        this.$emit("confirmCallback");
      } catch (error) {
        console.error("삭제 실패", error);
        this.$toast.error("삭제에 실패했습니다.");
      }
    },
    async doActionDocFileAttach() {
      const fileObject = this.$refs.actionDocFile.files[0];

      const docFileForm = FileHelper.createFileFormData(
        fileObject,
        this.param.fileId,
        0
      );
      const fileRes = await FileApi.upload(docFileForm, "DOCUMENT");
      if (fileRes.content) {
        this.param.fileId = fileRes.content.fileId;
        this.fileList = await FileApi.list(this.param.fileId);
      }

      const ocrData = fileRes.content.ocrData;
      const newData = {};
      ocrData.forEach((data) => {
        const fieldName = data.name;
        newData[fieldName] = data.inferText;
      });
      this.param.oilType = newData["oil_type"];
      this.param.oilAmount = newData["oil_amount"].replace(/,/g, "");
      this.param.unitPrice = newData["unit_price"].replace(/,/g, "");

      this.param.oilPrice =
        Number(newData["oil_price"].replace(/,/g, "")) +
        Number(newData["oil_vat"].replace(/,/g, ""));
      this.param.extraPrice =
        Number(newData["extra_price"].replace(/,/g, "")) +
        Number(newData["extra_vat"].replace(/,/g, ""));
      this.param.servicePrice =
        Number(newData["service_addition_price"].replace(/,/g, "")) +
        Number(newData["service_basic_price"].replace(/,/g, "")) +
        Number(newData["service_vat"].replace(/,/g, ""));
      this.param.totalPrice = Number(newData["total_price"].replace(/,/g, ""));
      this.param.supplyDay = newData["supplyDay"].replace(/\//g, "-");

      const ocrEquipName = newData["equipName"];
      const matchedEquip = this.equipList.find(
        (equip) => equip.name === ocrEquipName
      );
      if (!matchedEquip) {
        alert("선박명 읽어오지 못했습니다 직접 선택해주세요");
      } else {
        this.param.shipId = matchedEquip.id;
      }
    },
  },
};
</script>
<style scoped>
.popup .form_wrap .form_write .title {
  min-width: 90px;
  white-space: nowrap;
}
.v-toast {
  z-index: 10000000 !important;
}
.readonly-input {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #4fc3f7 !important;
  cursor: not-allowed;
}
.total-price {
  font-weight: bold;
  font-size: 16px;
  color: #ffca28 !important;
}
.file-input {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  flex: 1;
}
.file-upload-label {
  display: inline-block;
  padding: 8px 16px;
  background-color: #1976d2;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}
.file-upload-label:hover {
  background-color: #1565c0;
}
.no-file-text {
  color: #90a4ae;
  font-size: 13px;
}
.files {
  color: #4fc3f7;
  text-decoration: underline;
}
.file-del {
  color: #ef5350;
  cursor: pointer;
}
.file-del:hover {
  text-decoration: underline;
}
.form_write {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}
.number-input {
  text-align: right !important;
}
.popup_footer .foot_btns .delete {
  background-color: #ef5350;
  color: white;
  margin-right: auto;
}
.popup_footer .foot_btns .delete:hover {
  background-color: #d32f2f;
}
</style>
